export const TEST_CLASS_NAMES = {
  childPolicies: {
    main: 'child-policies',
    label: 'child-policies__label',
    content: 'child-policies__content',
    tableHeader: 'child-policies__table__header',
    tableBody: 'child-policies__table__body',
  },
};
